import ForbidPage from './src/ForbidPage.vue'
import _ForbidPageMobile from './src/ForbidPageMobile.vue'
import _useForbidPage from './logic'

export const ForbidPageMobile = _ForbidPageMobile

export const useForbidPage = _useForbidPage

export default ForbidPage
